import type { Command } from 'commander';
import { registerEnterpriseCompanyView } from './view';
import { registerEnterpriseCompanyUpdate } from './update';
import { registerEnterpriseCompanyLogo } from './logo';
import { registerEnterpriseCompanyReplace } from './replace';

export function registerEnterpriseCompanyCommand(parent: Command): void {
	const company = parent.command('company').description('View and manage your company information');
	registerEnterpriseCompanyView(company);
	registerEnterpriseCompanyUpdate(company);
	registerEnterpriseCompanyLogo(company);
	registerEnterpriseCompanyReplace(company);
}
